import { combineReducers } from "redux";

import auth from "./auth";
import clients from "./clients";
import audiences from "../entities/audience/audience.reducer";
import audiencesSlice from "../entities/audience/audience-slice.reducer";

import notifications from "./notifications";
import userProfile from "./userProfile";
import platforms from "./platforms";
import crm from "./crm";

// eslint-disable-next-line import/no-named-as-default
export default combineReducers({
  auth,
  clients,
  audiences,
  audienceSlice: audiencesSlice.reducer,
  notifications,
  userProfile,
  platforms,
  crm
});
